import { render } from "./Footer.vue?vue&type=template&id=363284bd&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=363284bd&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-363284bd"

export default script